import { actions, getUserCountryAsync } from './slices';
import * as thunks from './thunks';

export const CommonActions = {
  ...actions,
  ...thunks,
  getUserCountryAsync,
  // getUserCountryV2Async,
};
